<template>
  <div>
    <Form
      page-title="Edit Business"
      buttonName="Update"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateBusiness } from "@/API/BusinessAPIs";
import { submitAndNotify } from "../../../helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "showAdd"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      let updateBusinessdData = {
        id: formData.id,
        locales: formData.locales,
        media: formData.media,
        type: formData.type
      };

      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateBusiness(updateBusinessdData), callback);
    }
  }
};
</script>
<style></style>
